import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/residents/residents";

export const Route = createFileRoute("/admin/_residents/residents")({
  component: Page,
});
